export const SIGN_IN_USER = 'sign_in_user'
export const SIGN_IN_USER_SUCCESS = 'sign_in_user_success'
export const SIGN_IN_USER_FAILED = 'sign_in_user_failed'
export const SIGN_OUT_USER = 'sign_out_user'

export const GET_SELF = 'get_self'
export const GET_SELF_SUCCESS = 'get_self_success'
export const GET_SELF_FAILED = 'get_self_failed'

export const GET_COMMUNITY = 'GET_COMMUNITY'
export const GET_COMMUNITY_SUCCESS = 'GET_COMMUNITY_SUCCESS'
export const GET_COMMUNITY_FAILED = 'GET_COMMUNITY_FAILED'

export const VALIDATE_USER = 'validate_user'
export const VALIDATE_USER_SUCCESS = 'validate_user_success'
export const VALIDATE_USER_FAILED = 'validate_user_failed'

export const SHOW_ALERT = 'show_alert'
export const HIDE_ALERT = 'hide_alert'

export const SHOW_NEW_USER_MODAL = 'show_new_user_modal'
export const HIDE_NEW_USER_MODAL = 'hide_new_user_modal'

export const SHOW_EDIT_LAUNDRY_TYPE_MODAL = 'show_edit_laundry_type_modal'
export const HIDE_EDIT_LAUNDRY_TYPE_MODAL = 'hide_edit_laundry_type_modal'

export const SHOW_EDIT_BOOKING_RANGE_MODAL = 'show_edit_booking_range_modal'
export const HIDE_EDIT_BOOKING_RANGE_MODAL = 'hide_edit_booking_range_modal'

export const SHOW_EDIT_MAX_BOOKINGS_MODAL = 'show_edit_max_bookings_modal'
export const HIDE_EDIT_MAX_BOOKINGS_MODAL = 'hide_edit_max_bookings_modal'

export const SHOW_EDIT_INFORMATION_ITEM_MODAL =
  'show_edit_information_item_modal'
export const HIDE_EDIT_INFORMATION_ITEM_MODAL =
  'hide_edit_information_item_modal'

export const SHOW_CREATE_INFORMATION_ITEM_MODAL =
  'show_create_information_item_modal'
export const HIDE_CREATE_INFORMATION_ITEM_MODAL =
  'hide_create_information_item_modal'

export const SET_CURRENT_PAGE = 'set_current_page'

export const SHOW_UNBOOK_LAUNDRY_TIME_MODAL = 'show_unbook_laundry_time_modal'
export const HIDE_UNBOOK_LAUNDRY_TIME_MODAL = 'hide_unbook_laundry_time_modal'

export const SHOW_CREATE_BOOKING_SYSTEM_MODAL =
  'show_create_booking_system_modal'
export const HIDE_CREATE_BOOKING_SYSTEM_MODAL =
  'hide_create_booking_system_modal'

export const SHOW_EDIT_BOOKING_SYSTEM_MODAL = 'show_edit_booking_system_modal'
export const HIDE_EDIT_BOOKING_SYSTEM_MODAL = 'hide_edit_booking_system_modal'

export const SHOW_CREATE_BOOKING_SYSTEM_TIME_MODAL =
  'show_create_booking_system_time_modal'
export const HIDE_CREATE_BOOKING_SYSTEM_TIME_MODAL =
  'hide_create_booking_system_time_modal'

export const SHOW_EDIT_BOOKING_SYSTEM_TIME_MODAL =
  'show_edit_booking_system_time_modal'
export const HIDE_EDIT_BOOKING_SYSTEM_TIME_MODAL =
  'edit_edit_booking_system_time_modal'

// User actions
export const CREATE_USER = 'create_user'
export const CREATE_USER_SUCCESS = 'create_user_success'
export const CREATE_USER_FAILED = 'create_user_failed'

export const DELETE_USER = 'delete_user'
export const DELETE_USER_SUCCESS = 'delete_user_success'
export const DELETE_USER_FAILED = 'delete_user_failed'

export const UPDATE_USER = 'update_user'
export const UPDATE_USER_SUCCESS = 'update_user_success'
export const UPDATE_USER_FAILED = 'update_user_failed'

export const SHOW_EDIT_USER_MODAL = 'show_edit_user_modal'
export const HIDE_EDIT_USER_MODAL = 'hide_edit_user_modal'

export const SHOW_SNACKBAR = 'show_snackbar'
export const HIDE_SNACKBAR = 'hide_snackbar'

// Community actions
export const SET_SELECTED_COMMUNITY = 'set_selected_community'
export const SHOW_SELECT_COMMUNITY_MODAL = 'show_select_community_modal'
export const HIDE_SELECT_COMMUNITY_MODAL = 'hide_select_community_modal'

// Laundry system actions
export const GET_LAUNDRY_BOOKING_SYSTEM = 'get_laundry_booking_system'
export const GET_LAUNDRY_BOOKING_SYSTEM_SUCCESS =
  'get_laundry_booking_system_success'
export const GET_LAUNDRY_BOOKING_SYSTEM_FAILED =
  'get_laundry_booking_system_failed'

// Laundry time actions
export const SHOW_EDIT_LAUNDRY_TIME_MODAL = 'show_edit_laundry_time_modal'
export const HIDE_EDIT_LAUNDRY_TIME_MODAL = 'hide_edit_laundry_time_modal'

export const SHOW_CREATE_LAUNDRY_TIME_MODAL = 'show_create_laundry_time_modal'
export const HIDE_CREATE_LAUNDRY_TIME_MODAL = 'hide_create_laundry_time_modal'

export const UPDATE_LAUNDRY_TIME = 'update_laundry_time'
export const UPDATE_LAUNDRY_TIME_SUCCESS = 'update_laundry_time_success'
export const UPDATE_LAUNDRY_TIME_FAILED = 'update_laundry_time_failed'

export const CREATE_LAUNDRY_TIME = 'create_laundry_time'
export const CREATE_LAUNDRY_TIME_SUCCESS = 'create_laundry_time_success'
export const CREATE_LAUNDRY_TIME_FAILED = 'create_laundry_time_failed'

export const DELETE_LAUNDRY_TIME = 'deleted_laundry_time'
export const DELETE_LAUNDRY_TIME_SUCCESS = 'deleted_laundry_time_success'
export const DELETE_LAUNDRY_TIME_FAILED = 'deleted_laundry_time_failed'

// Laundry actions
export const SHOW_EDIT_LAUNDRY_MODAL = 'show_edit_laundry_modal'
export const HIDE_EDIT_LAUNDRY_MODAL = 'hide_edit_laundry_modal'

export const SHOW_CREATE_LAUNDRY_MODAL = 'show_create_laundry_modal'
export const HIDE_CREATE_LAUNDRY_MODAL = 'hide_create_laundry_modal'

export const CREATE_LAUNDRY = 'create_laundry'
export const CREATE_LAUNDRY_SUCCESS = 'create_laundry_success'
export const CREATE_LAUNDRY_FAILED = 'create_laundry_failed'

export const UPDATE_LAUNDRY = 'update_laundry'
export const UPDATE_LAUNDRY_SUCCESS = 'update_laundry_success'
export const UPDATE_LAUNDRY_FAILED = 'update_laundry_failed'

export const DELETE_LAUNDRY = 'delete_laundry'
export const DELETE_LAUNDRY_SUCCESS = 'delete_laundry_success'
export const DELETE_LAUNDRY_FAILED = 'delete_laundry_failed'

// Laundry rules actions
export const UPDATE_LAUNDRY_RULES = 'update_laundry_rules'
export const UPDATE_LAUNDRY_RULES_SUCCESS = 'update_laundry_rules_success'
export const UPDATE_LAUNDRY_RULES_FAILED = 'update_laundry_rules_failed'

// Information item actions
export const GET_INFORMATION_ITEMS = 'get_information_items'
export const GET_INFORMATION_ITEMS_SUCCESS = 'get_information_items_success'
export const GET_INFORMATION_ITEMS_FAILED = 'get_information_items_failed'

export const CREATE_INFORMATION_ITEM = 'create_information_item'
export const CREATE_INFORMATION_ITEM_SUCCESS = 'create_information_item_success'
export const CREATE_INFORMATION_ITEM_FAILED = 'create_information_item_failed'

export const UPDATE_INFORMATION_ITEM = 'update_information_item'
export const UPDATE_INFORMATION_ITEM_SUCCESS = 'update_information_item_success'
export const UPDATE_INFORMATION_ITEM_FAILED = 'update_information_item_failed'

export const DELETE_INFORMATION_ITEM = 'delete_information_item'
export const DELETE_INFORMATION_ITEM_SUCCESS = 'delete_information_item_success'
export const DELETE_INFORMATION_ITEM_FAILED = 'delete_information_item_failed'

// Booking actions
export const CREATE_BOOKING = 'create_booking'
export const CREATE_BOOKING_SUCCESS = 'create_booking_success'
export const CREATE_BOOKING_FAILED = 'create_booking_failed'

export const DELETE_BOOKING = 'delete_booking'
export const DELETE_BOOKING_SUCCESS = 'delete_booking_success'
export const DELETE_BOOKING_FAILED = 'delete_booking_failed'

// Booking system actions
export const CREATE_BOOKING_SYSTEM = 'create_booking_system'
export const CREATE_BOOKING_SYSTEM_SUCCESS = 'create_booking_system_success'
export const CREATE_BOOKING_SYSTEM_FAILED = 'create_booking_system_failed'

export const GET_BOOKING_SYSTEM = 'get_booking_system'
export const GET_BOOKING_SYSTEM_SUCCESS = 'get_booking_system_success'
export const GET_BOOKING_SYSTEM_FAILED = 'get_booking_system_failed'

export const DELETE_BOOKING_SYSTEM = 'delete_booking_system'
export const DELETE_BOOKING_SYSTEM_SUCCESS = 'delete_booking_system_success'
export const DELETE_BOOKING_SYSTEM_FAILED = 'delete_booking_system_failed'

export const UPDATE_BOOKING_SYSTEM = 'update_booking_system'
export const UPDATE_BOOKING_SYSTEM_SUCCESS = 'update_booking_system_success'
export const UPDATE_BOOKING_SYSTEM_FAILED = 'update_booking_system_failed'

// Booking system time actions
export const CREATE_BOOKING_SYSTEM_TIME = 'create_booking_system_time'
export const CREATE_BOOKING_SYSTEM_TIME_SUCCESS =
  'create_booking_system_time_success'
export const CREATE_BOOKING_SYSTEM_TIME_FAILED =
  'create_booking_system_time_failed'

export const DELETE_BOOKING_SYSTEM_TIME = 'delete_booking_system_time'
export const DELETE_BOOKING_SYSTEM_TIME_SUCCESS =
  'delete_booking_system_time_success'
export const DELETE_BOOKING_SYSTEM_TIME_FAILED =
  'delete_booking_system_time_failed'

export const UPDATE_BOOKING_SYSTEM_TIME = 'update_booking_system_time'
export const UPDATE_BOOKING_SYSTEM_TIME_SUCCESS =
  'update_booking_system_time_success'
export const UPDATE_BOOKING_SYSTEM_TIME_FAILED =
  'update_booking_system_time_failed'

// News feed actions
export const GET_POSTS = 'get_posts'
export const GET_POSTS_SUCCESS = 'get_posts_success'
export const GET_POSTS_FAILED = 'get_posts_failed'

export const CREATE_POST = 'create_post'
export const CREATE_POST_SUCCESS = 'create_post_success'
export const CREATE_POST_FAILED = 'create_post_failed'

export const DELETE_POST = 'delete_post'
export const DELETE_POST_SUCCESS = 'delete_post_success'
export const DELETE_POST_FAILED = 'delete_post_failed'

export const DELETE_COMMENT = 'delete_comment'
export const DELETE_COMMENT_SUCCESS = 'delete_comment_success'
export const DELETE_COMMENT_FAILED = 'delete_comment_failed'

// Apartment actions
export const RESET_APARTMENT = 'reset_apartment'
export const RESET_APARTMENT_SUCCESS = 'reset_apartment_success'
export const RESET_APARTMENT_FAILED = 'reset_apartment_failed'

export const GET_APARTMENT_CODE = 'get_apartment_code'
export const GET_APARTMENT_CODE_SUCCESS = 'get_apartment_code_success'
export const GET_APARTMENT_CODE_FAILED = 'get_apartment_code_failed'

export const TOGGLE_APARTMENT_VISIBILITY = 'toggle_apartment_visibility'
export const TOGGLE_APARTMENT_VISIBILITY_SUCCESS = 'toggle_apartment_visibility_success'
export const TOGGLE_APARTMENT_VISIBILITY_FAIL = 'toggle_apartment_visibility_fail'

export const TOGGLE_LAUNDRY_VISIBILITY = 'toggle_laundry_visibility'
export const TOGGLE_LAUNDRY_VISIBILITY_SUCCESS = 'toggle_laundry_visibility_success'
export const TOGGLE_LAUNDRY_VISIBILITY_FAIL = 'toggle_laundry_visibility_fail'



// WEBPACK FOOTER //
// ./src/components/actions/Types.js